import axiosLogin from "global/helpers/axiosLogin";

export const wsGetOrdenesDigitalesById = (nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/ordenes-digitales/misOrdenes`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const wsGetGrupoByIdOrden = (id, nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/ordenes-digitales/items/${id}`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const wsGetPDFOrdenEstudio = (id, nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/ordenes-digitales/pdf/${id}/pdf`, { responseType: "blob" })
      .then((resp) => {
        const blob = resp.data;
        if (nextStep) nextStep(true, { blob });
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};
